import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_filePreview } from '../Controls/dbh_filePreview';
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';
import { dbh_loading } from '../src/dbh_loading';

declare var dbhCarouselSachkostenbeleg: any;

if (dbh_helper.getUrlArea() == "workflows" && dbh_helper.getUrlController() == "sachkostenabrechnungen") {
    $(document).ready(function () {
        var isFirstLoad = true;
        $('#dbh_workflowSachkostenabrechnungBelegDetails').ready(() => {

            if (isFirstLoad && $('#dbh_workflowSachkostenabrechnungBelegDetails').length > 0) {
                new dbh_ajax().sendGetRequest({
                    actionName: "GetBelegDetailsPartial",
                    controllerName: "Workflows/Sachkostenabrechnungen",
                    parameter: [["id", $('#PK_SachkostenkontenBuchungen').val().toString()], ["isDesktop", ($(window).width() > 500).toString()]],
                    callbackSuccess: (ajaxResult: any) => {
                        $('#partialContentPlaceholder').html(ajaxResult.responseText);
                        isFirstLoad = false;
                        initialize();
                    }
                });
            }

            function initialize() {

                /**
                 * Anlegen und bearbeiten
                 */

                $(document).off("click", ".btnBildEntfernen");
                $(document).on("click", ".btnBildEntfernen", function (e) {
                    if (!confirm('Soll das Bild wirklich unwiderruflich gelöscht werden?')) { return false; }

                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "FotoLoeschen",
                        controllerName: "Workflows/Sachkostenabrechnungen",
                        parameter: [["id", $(e.currentTarget).attr("data-id")]],
                        callbackSuccess: (ajaxResult: any) => {
                            let index = parseInt($(e.currentTarget).parent().attr('id').slice(-1)) - 1;
                            let slide = $(`#belegCarousel .f-carousel__slide[data-index="${index}"]`);

                            slide.fadeOut('slow', function () {
                                $(`#belegButtons${(index + 1)}`).remove();

                                // belegButtons neu nummerieren, damit andere Funktionen weiterhin laufen
                                var counter = 1;
                                $('.belegButtons').each((index, elem) => {
                                    $(elem).attr('id', `belegButtons${counter}`);
                                    counter++;
                                });

                                dbhCarouselSachkostenbeleg.removeSlide(index);

                                if ($('#belegCarousel .f-carousel__slide').length == 0) {
                                    $('#belegCarousel .f-carousel__track').append($('<div class="f-carousel__slide is-selected dbhBildPlatzhalterPanel" data-index="0"><div title="Bild hinzufügen..." class="dbhBildPlatzhalter kamera"><span>Bild hinzufügen...</span></div></div>'));
                                    bindePlatzhalterFuerErstenUpload();
                                    $('#anzahlBilderIndex').html("0");
                                    $('#anzahlBilderMax').html("0");
                                }
                                else {
                                    $('#belegCarousel').find('.dbhBildPlatzhalter .f-carousel__slide').parents().remove();

                                    // buttons der neuen Folie einblenden
                                    $('#belegButtons' + (dbhCarouselSachkostenbeleg.getPageFromPosition().pageIndex + 1)).show();
                                    zaehleBilderZuBeleg();
                                }
                            });
                        }
                    });
                });

                // Mobile Endgeräte bekommen bewusst keinen "multiple"-Input mehr, da dies (v.a. auf iPhone) in Kombination
                // mit Kamera-Capture gelegentlich zu einem Einfrieren der Seite nach dem Tippen auf "Verwenden" führte.
                // Auf iPhone wird PDF als Dateiformat für die Kamera-Aufnahme nicht unterstützt bzw. sinnvoll angeboten -> daher dort ohne PDF im accept-Attribut
                if (dbh_helper.isIPhone()) {
                    $("#fileNeuesFoto").attr("accept", "image/*");
                }

                // Bindet den change-Handler an das aktuell im DOM befindliche #fileNeuesFoto-Element.
                // Wird nach jedem Upload-Versuch erneut aufgerufen, da das Input-Element bei einem
                // Abbruch/Fehler per Klon ersetzt wird (Workaround für iOS-PWA/WKWebView-Standalone-
                // Modus: dort wird das native File-Handle nach der ersten Nutzung nicht zuverlässig
                // freigegeben, wodurch ein reines Zurücksetzen von input.value nicht ausreicht, um
                // einen zweiten Foto-Upload zu ermöglichen - im normalen Safari-Tab tritt dieses
                // Verhalten nicht auf).
                const bindFileNeuesFotoChangeHandler = () => {
                    const $fileNeuesFoto = $("#fileNeuesFoto");
                    $fileNeuesFoto.off("change");
                    $fileNeuesFoto.on("change", function (e) {
                        // Sofortiges Lade-Feedback, damit die (bei hochauflösenden Fotos ggf. länger dauernde) native Bildverarbeitung nicht wie ein Einfrieren der App wirkt.
                        var loading = new dbh_loading();
                        loading.onLoading("dbh_workflowSachkostenabrechnungBelegDetails");

                        var input = this as HTMLInputElement;
                        if (input.files && input.files[0]) {
                            const extension = input.files[0].name.split('.').pop().toLocaleLowerCase();
                            const size = input.files[0].size;
                            const allowedExtension = [".jpg", ".jpeg", ".png", ".tiff", ".pdf"];
                            let error = false;
                            var form: JQuery<HTMLFormElement> = dbh_helper.findNearestFormJquery($(e.currentTarget));
                            var formData = new FormData(form.get(0));

                            if (size > (10 * 1024 * 1024)) {
                                setTimeout(() => alert('Die Datei darf nicht größer als 10 MB sein.'), 0);
                                error = true;
                            }
                            else if (allowedExtension.indexOf(`.${extension}`) == -1) {
                                setTimeout(() => alert('Es sind nur die Formate jpg, jpeg, tiff, png und pdf erlaubt.'), 0);
                                error = true;
                            }
                            else {
                                formData.append("id", $('#PK_SachkostenkontenBuchungen').val().toString());
                                formData.append("fk_SachkostenkontenAbrechnungen", $('#FK_SachkostenkontenAbrechnungen').val().toString());

                                for (var i = 0; i < input.files.length; i++) {
                                    formData.append("foto" + i.toString(), input.files[i], input.files[i].name);
                                }
                            }

                            const resetFileInput = () => {
                                // Input-Element klonen und ersetzen statt nur input.value zurückzusetzen:
                                // in der iOS-PWA (WKWebView Standalone) reicht ein reines Zurücksetzen
                                // des value nicht zuverlässig aus, um einen erneuten Foto-Upload zu ermöglichen.
                                const $oldInput = $("#fileNeuesFoto");
                                const $newInput = $oldInput.clone(false);
                                $newInput.val("");
                                $oldInput.replaceWith($newInput);
                                bindFileNeuesFotoChangeHandler();
                            };

                            if (!error) {
                                new dbh_ajax().sendPostRequest({
                                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                    actionName: "FotoHinzufuegen",
                                    processData: false, // wichtig für File-Upload
                                    contentType: false, // wichtig für File-Upload
                                    controllerName: "WorkflowS/Sachkostenabrechnungen",
                                    parameter: formData,
                                    callbackSuccess: (ajaxResult: any) => {
                                        window.location.href = `/workflows/Sachkostenabrechnungen/BelegDetails?id=${ajaxResult}&neuesBild=1`;
                                    },
                                    callbackError: () => {
                                        loading.onLoadingFinished();
                                        resetFileInput();
                                    }
                                });
                            }
                            else {
                                loading.onLoadingFinished();
                                resetFileInput();
                            }
                        }
                        else {
                            loading.onLoadingFinished();
                        }
                    });
                };

                bindFileNeuesFotoChangeHandler();

                $("#fileAktualisiertesFoto").off("change");
                $("#fileAktualisiertesFoto").on("change", function (e) {
                    var input = this as HTMLInputElement;

                    var form: JQuery<HTMLFormElement> = dbh_helper.findNearestFormJquery($(e.currentTarget));
                    var formData = new FormData(form.get(0));

                    formData.append("id", $(input).attr('data-file-id'));

                    fetch($(input).val() as any).then((response: any) => {
                        response.blob().then((x) => {
                            formData.append("foto", x, $(input).attr('data-filename'));

                            new dbh_ajax().sendPostRequest({
                                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                actionName: "FotoAktualisieren",
                                processData: false, // wichtig für File-Upload
                                contentType: false, // wichtig für File-Upload
                                controllerName: "WorkflowS/Sachkostenabrechnungen",
                                parameter: formData,
                                callbackSuccess: (ajaxResult: any) => {

                                }
                            });
                        });
                    });
                });

                $(document).off("click", "#dbhBtnBelegLoeschen");
                $(document).on("click", "#dbhBtnBelegLoeschen", function (e) {
                    dbh_helper.SendGetRequest("BelegLoeschenPopupView", "Workflows/Sachkostenabrechnungen", [['id', $('#PK_SachkostenkontenBuchungen').val()]], '#popup-placeholder', function () {
                        $("#PopupSachkostenabrechnungBelegLoeschenViewComponent").show();
                    });

                    e.stopPropagation();
                });

                $(document).off("click", "#PopupSachkostenabrechnungBelegLoeschenViewComponent #SachkostenabrechnungBelegLoeschenSavetBtn");
                $(document).on("click", "#PopupSachkostenabrechnungBelegLoeschenViewComponent #SachkostenabrechnungBelegLoeschenSavetBtn", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "BelegLoeschen",
                        controllerName: "Workflows/Sachkostenabrechnungen",
                        parameter: [["id", $('#PK_SachkostenkontenBuchungen').val()]],
                        callbackSuccess: (ajaxResult: any) => {
                            $("body").html(ajaxResult);
                        }
                    });
                });

                $(document).off("click", "#PopupSachkostenabrechnungBelegLoeschenViewComponent #SachkostenabrechnungBelegLoeschenCancelBtn");
                $(document).on("click", "#PopupSachkostenabrechnungBelegLoeschenViewComponent #SachkostenabrechnungBelegLoeschenCancelBtn", function () {
                    $("#PopupSachkostenabrechnungBelegLoeschenViewComponent").hide();
                });

                /**
                 * Initialisierung
                 */

                if ($("#FK_SachkostenKategorien").length > 0) {
                    $("#FK_SachkostenKategorien").data("kendoComboBox").bind("change", () => {
                        var Kategorie = $("#FK_SachkostenKategorien").data("kendoComboBox").dataItem();

                        // Änderung - es soll immer möglich sein, eine Kostenstelle einzutragen

                        //if (Kategorie != null && Kategorie != undefined && Kategorie.Value != null && Kategorie.Value != undefined && Kategorie.Value == "c8fef6c8-8f88-4b46-b768-5be0f465ea7c") {
                        //    if (!$('.kostenstelle').hasClass('active')) {
                        //        $('.kostenstelle').addClass('active');
                        //        $('.kostenstelle .form-text').attr('required', 'required');
                        //    }
                        //}
                        //else {
                        //    $('.kostenstelle').removeClass('active');
                        //    $('.kostenstelle .form-text').removeAttr('required');
                        //}

                        if (Kategorie != null && Kategorie != undefined && Kategorie.Value != null && Kategorie.Value != undefined) {
                            localStorage["dbhReminderSachkostenKategorien"] = Kategorie.Value;
                            $("#FK_SachkostenKategorien").parent('.k-combobox').removeClass("input-validation-error");
                            $("#FK_SachkostenKategorien").parent('.k-combobox').attr('title', '');
                            $('#dbhBtnAdd').removeAttr("disabled");
                        }
                        else {
                            localStorage["dbhReminderSachkostenKategorien"] = "";
                            $("#FK_SachkostenKategorien").parent('.k-combobox').addClass("input-validation-error");
                            $("#FK_SachkostenKategorien").parent('.k-combobox').attr('title', 'Es muss eine Kategorie ausgewählt werden!');
                            $('#dbhBtnAdd').attr("disabled", "disabled");
                        }

                        // Änderung - keine Vorauswahl, da es den Eingabeprozess am Telefon etwas erschwert

                        // else {
                        //    // wenn nichts ausgewählt, dann immer den ersten Wert vorauswählen
                        //    $("#FK_SachkostenKategorien").data("kendoComboBox").value(
                        //        $("#FK_SachkostenKategorien").data("kendoComboBox").dataSource._data[0].Value
                        //    );
                        //}
                    });
                }
                
                if ($("#FK_SachkostenKategorien2").length > 0) {
                    $("#FK_SachkostenKategorien2").data("kendoComboBox").bind("change", () => {
                        var Kategorie = $("#FK_SachkostenKategorien2").data("kendoComboBox").dataItem();

                        if (Kategorie != null && Kategorie != undefined && Kategorie.Value != null && Kategorie.Value != undefined) {
                            localStorage["dbhReminderSachkostenKategorien2"] = Kategorie.Value;
                        }
                        else {
                            localStorage["dbhReminderSachkostenKategorien2"] = "";
                        }
                    });
                }

                // wenn ein neues Bild hochgeladen wurde, wird die Siete neu geladen. Damit das neue Bild dann direkt angezeigt wird, wird der Slider einmal nach links aktiviert.
                if (window.location.href.indexOf("neuesBild=1") > -1) {

                    // vorher eingetragene Werte wieder setzen
                    // Reminder der Beleg-Detailseite zurücksetzen
                    if (localStorage["dbhReminderZweck"] != null && localStorage["dbhReminderZweck"] != undefined && localStorage["dbhReminderZweck"] != "undefined") {
                        $('#Zweck').val(localStorage["dbhReminderZweck"]);
                    }
                    if (localStorage["dbhReminderBetrag"] != null && localStorage["dbhReminderBetrag"] != undefined && localStorage["dbhReminderBetrag"] != "undefined") {
                        $('#BetragString').val(localStorage["dbhReminderBetrag"]);
                    }
                    if (localStorage["dbhReminderKostenstelle"] != null && localStorage["dbhReminderKostenstelle"] != undefined && localStorage["dbhReminderKostenstelle"] != "undefined") {
                        $('#Kostenstelle').val(localStorage["dbhReminderKostenstelle"]);
                    }
                    if (localStorage["dbhReminderNotiz"] != null && localStorage["dbhReminderNotiz"] != undefined && localStorage["dbhReminderNotiz"] != "undefined") {
                        $('#Notiz').val(localStorage["dbhReminderNotiz"]);
                    }
                    if (localStorage["dbhReminderDatum"] != null && localStorage["dbhReminderDatum"] != undefined && localStorage["dbhReminderDatum"] != "undefined") {
                        $("#calendar").data("kendoCalendar").value(new Date(localStorage["dbhReminderDatum"]));
                    }
                    if (localStorage["dbhReminderFK_SachkostenKategorien"] != null && localStorage["dbhReminderFK_SachkostenKategorien"] != undefined && localStorage["dbhReminderFK_SachkostenKategorien"] != "undefined") {
                        window.setTimeout(() => {
                            $("#FK_SachkostenKategorien").data("kendoComboBox").value(localStorage["dbhReminderFK_SachkostenKategorien"]);
                            // Änderung - Kostenstelle immer anzeigen
                            //if (localStorage["dbhReminderFK_SachkostenKategorien"] == "c8fef6c8-8f88-4b46-b768-5be0f465ea7c") {
                            //    if (!$('.kostenstelle').hasClass('active')) {
                            //        $('.kostenstelle').addClass('active');
                            //        $('.kostenstelle .form-text').attr('required', 'required');
                            //    }
                            //}
                        }, 250);
                    }

                    try {
                        dbhCarouselSachkostenbeleg.slidePrev();
                    } catch (e) {
                        window.setTimeout(() => {
                            dbhCarouselSachkostenbeleg.slidePrev();
                        }, 500);
                    }
                }

                bindePlatzhalterFuerErstenUpload();

                bindeDragDropFuerDateien();
            }
        });

        $('#dbh_workflowSachkostenabrechnungDetails').ready(() => {
            if (window.location.href.indexOf("neuesBild=1") <= -1) {
                // Reminder der Beleg-Detailseite zurücksetzen
                localStorage.removeItem("dbhReminderZweck");
                localStorage.removeItem("dbhReminderBetrag");
                localStorage.removeItem("dbhReminderKostenstelle");
                localStorage.removeItem("dbhReminderNotiz");
                localStorage.removeItem("dbhReminderDatum");
                localStorage.removeItem("dbhReminderFK_SachkostenKategorien");
            }

            /**
             * Freigabe und Ablehnen
             */

            $(document).off("click", "#dbhBtnLogbuch");
            $(document).on("click", "#dbhBtnLogbuch", function (e) {
                dbh_helper.SendGetRequest("SachkostenabrechnungLogbuchPopupView", "Workflows/Sachkostenabrechnungen", [['id', $('#PK_SachkostenkontenAbrechnungen').val()]], '#popup-placeholder', function () {
                    $("#PopupSachkostenabrechnungLogbuchViewComponent").show();
                });

                e.stopPropagation();
            });

            $(document).off("click", "#dbhBtnEinreichen");
            $(document).on("click", "#dbhBtnEinreichen", function (e) {
                dbh_helper.SendGetRequest("SachkostenabrechnungEinreichenPopupView", "Workflows/Sachkostenabrechnungen", [['id', $('#PK_SachkostenkontenAbrechnungen').val()]], '#popup-placeholder', function () {
                    $("#PopupSachkostenabrechnungEinreichenViewComponent").show();
                });

                e.stopPropagation();
            });
            $(document).off("click", "#PopupSachkostenabrechnungEinreichenViewComponent #SachkostenabrechnungEinreichenSavetBtn");
            $(document).on("click", "#PopupSachkostenabrechnungEinreichenViewComponent #SachkostenabrechnungEinreichenSavetBtn", function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);

                new dbh_ajax().sendPostRequest({
                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    actionName: "SachkostenabrechnungEinreichen",
                    controllerName: "Workflows/Sachkostenabrechnungen",
                    parameter: [["id", $('#PK_SachkostenkontenAbrechnungen').val()],
                        ["bankdatenNeuBankverbindung", $('#BankdatenNeuBankverbindung').val()],
                        ["bankdatenNeuIban", $('#BankdatenNeuIban').val()]],
                    callbackSuccess: (ajaxResult: any) => {
                        $("body").html(ajaxResult);
                    }
                });
            });
            $(document).off("click", "#PopupSachkostenabrechnungEinreichenViewComponent #SachkostenabrechnungEinreichenCancelBtn");
            $(document).on("click", "#PopupSachkostenabrechnungEinreichenViewComponent #SachkostenabrechnungEinreichenCancelBtn", function () {
                $("#PopupSachkostenabrechnungEinreichenViewComponent").hide();
            });


            $(document).off("click", "#dbhBtnFreigeben");
            $(document).on("click", "#dbhBtnFreigeben", function (e) {
                dbh_helper.SendGetRequest("SachkostenabrechnungFreigebenPopupView", "Workflows/Sachkostenabrechnungen", [['id', $('#PK_SachkostenkontenAbrechnungen').val()]], '#popup-placeholder', function () {
                    $("#PopupSachkostenabrechnungFreigebenViewComponent").show();
                });

                e.stopPropagation();
            });

            $(document).off("click", "#PopupSachkostenabrechnungFreigebenViewComponent #SachkostenabrechnungFreigebenSavetBtn");
            $(document).on("click", "#PopupSachkostenabrechnungFreigebenViewComponent #SachkostenabrechnungFreigebenSavetBtn", function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);

                new dbh_ajax().sendPostRequest({
                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    actionName: "SachkostenabrechnungFreigeben",
                    controllerName: "Workflows/Sachkostenabrechnungen",
                    parameter: [["id", $('#PK_SachkostenkontenAbrechnungen').val()]],
                    callbackSuccess: (ajaxResult: any) => {
                        $("body").html(ajaxResult);
                    }
                });
            });

            $(document).off("click", "#PopupSachkostenabrechnungFreigebenViewComponent #SachkostenabrechnungFreigebenCancelBtn");
            $(document).on("click", "#PopupSachkostenabrechnungFreigebenViewComponent #SachkostenabrechnungFreigebenCancelBtn", function () {
                $("#PopupSachkostenabrechnungFreigebenViewComponent").hide();
            });


            $(document).off("click", "#dbhBtnAblehnen");
            $(document).on("click", "#dbhBtnAblehnen", function (e) {
                dbh_helper.SendGetRequest("SachkostenabrechnungAblehnenPopupView", "Workflows/Sachkostenabrechnungen", [['id', $('#PK_SachkostenkontenAbrechnungen').val()]], '#popup-placeholder', function () {
                    $("#PopupSachkostenabrechnungAblehnenViewComponent").show();
                });

                e.stopPropagation();
            });

            $(document).off("click", "#PopupSachkostenabrechnungAblehnenViewComponent #SachkostenabrechnungAblehnenSavetBtn");
            $(document).on("click", "#PopupSachkostenabrechnungAblehnenViewComponent #SachkostenabrechnungAblehnenSavetBtn", function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);

                new dbh_ajax().sendPostRequest({
                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    actionName: "SachkostenabrechnungAblehnen",
                    controllerName: "Workflows/Sachkostenabrechnungen",
                    parameter: [["id", $('#PK_SachkostenkontenAbrechnungen').val()],
                    ["begruendung", $('#Begruendung').val()]],
                    callbackSuccess: (ajaxResult: any) => {
                        $("body").html(ajaxResult);
                    }
                });
            });
            $(document).off("click", "#PopupSachkostenabrechnungAblehnenViewComponent #SachkostenabrechnungAblehnenCancelBtn");
            $(document).on("click", "#PopupSachkostenabrechnungAblehnenViewComponent #SachkostenabrechnungAblehnenCancelBtn", function () {
                $("#PopupSachkostenabrechnungAblehnenViewComponent").hide();
            });
        });
    });
}

function bindeDragDropFuerDateien() {

    $(".dbhBildPlatzhalterPanel").on(
        'dragover',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    )
    $(".dbhBildPlatzhalterPanel").on(
        'dragenter',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    )

    $(".dbhBildPlatzhalterPanel").on(
        'drop', function (e) {
            if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length && e.originalEvent.dataTransfer.files.length > 0) {
                e.preventDefault();
                e.stopPropagation();

                const dataTransfer = new DataTransfer();
                for (var i = 0; i < e.originalEvent.dataTransfer.files.length; i++) {
                    dataTransfer.items.add(e.originalEvent.dataTransfer.files[i]);
                }
                ($("#fileNeuesFoto").get(0) as any).files = dataTransfer.files;
                $("#fileNeuesFoto").trigger('change');
            }
        }
    );
}

function bindePlatzhalterFuerErstenUpload() {
    $(".dbhBildPlatzhalter").off("click");
    $(".dbhBildPlatzhalter").on("click", () => {
        $('.btnBildHinzufuegen').get(0).click();
    });
}

function zaehleBilderZuBeleg() {
    $('#anzahlBilderIndex').html(dbhCarouselSachkostenbeleg.getPageFromPosition().pageIndex + 1);
    $('#anzahlBilderMax').html($('#belegCarousel .f-carousel__slide').length.toString());
}